import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import { AuthProvider } from "./lib/auth";
import { BrandingProvider } from "./lib/branding";
import { MediaPlayerProvider } from "./lib/player";
import MiniPlayer from "./components/MiniPlayer";
import Landing from "./pages/Landing";
import ArticlePage from "./pages/ArticlePage";
import SubmitPage from "./pages/SubmitPage";
import DiscoverPage from "./pages/DiscoverPage";
import AdminLogin from "./pages/AdminLogin";
import AdminReset from "./pages/AdminReset";
import AdminDashboard from "./pages/AdminDashboard";
import CategoryPage from "./pages/CategoryPage";
import SearchPage from "./pages/SearchPage";
import ArtistPage from "./pages/ArtistPage";
import ArtistsDirectoryPage from "./pages/ArtistsDirectoryPage";
import MediaListPage from "./pages/MediaListPage";
import ShopPage from "./pages/ShopPage";
import ShopSuccess from "./pages/ShopSuccess";
import HelpPage from "./pages/HelpPage";
import LegalPage from "./pages/LegalPage";
import StoryPage from "./pages/StoryPage";
import CommunityPage from "./pages/CommunityPage";
import GoogleCallback from "./pages/GoogleCallback";

function AppRoutes() {
    const location = useLocation();
    // Read the fragment from useLocation().hash (reactive) — catches the OAuth
    // return BEFORE any protected route runs, avoiding a redirect race.
    if (location.hash?.includes("session_id=")) {
        return <GoogleCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/article/:slug" element={<ArticlePage />} />
            <Route path="/category/:name" element={<CategoryPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/artist/:id" element={<ArtistPage />} />
            <Route path="/artists" element={<ArtistsDirectoryPage />} />
            <Route path="/m/:kind" element={<MediaListPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/shop/success" element={<ShopSuccess />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/terms" element={<LegalPage doc="terms" title="Terms & Conditions" description="MyStreetzMag terms of use, content licensing, shop terms and disclaimers." />} />
            <Route path="/privacy" element={<LegalPage doc="privacy" title="Privacy Policy" description="What data MyStreetzMag collects, how we use it, and your rights." />} />
            <Route path="/submit" element={<SubmitPage />} />
            <Route path="/story" element={<StoryPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/discover" element={<DiscoverPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset" element={<AdminReset />} />
            <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App bg-black text-white min-h-screen">
            <HelmetProvider>
                <BrandingProvider>
                    <AuthProvider>
                        <MediaPlayerProvider>
                        <BrowserRouter>
                        <AppRoutes />
                        <MiniPlayer />
                    </BrowserRouter>
                    <Toaster
                        theme="dark"
                        position="top-right"
                        toastOptions={{ style: { background: "#111", color: "#fff", border: "1px solid #262626" } }}
                    />
                        </MediaPlayerProvider>
                    </AuthProvider>
            </BrandingProvider>
            </HelmetProvider>
        </div>
    );
}

export default App;
